import Vue from 'vue'
import App from './App.vue'
import router from './router'
import VueMaterial from 'vue-material'
import 'vue-material/dist/vue-material.min.css'
import 'vue-material/dist/theme/default.css'
import Vuex from 'vuex'
import money from 'v-money'
import vuetify from './plugins/vuetify'

Vue.use(Vuex)
Vue.use(require('vue-moment'));
Vue.use(money, {precision: 4})
Vue.config.productionTip = false
Vue.use(VueMaterial)

new Vue({
  router,
  vuetify,
  render: h => h(App)
}).$mount('#app')
